class Conciliation {
    public id: number;
    public id_ips: string;
    public id_creditor: string;
    public programming: string;
    public date_conciliation: string;
    public modality_conciliation: string;
    public balance_conciliation: string;
    public explanation: string;
    public refund: string;
    public observations: string;
    public is_active: string;
    public id_creditor__name_creditor?: string;
    public id_ips__nombre_ips?: string;
    public id_ips__municipio_id__codigo_municipio?: string;
    public id_creditor__type_creditor?: string;
    public id_creditor__document_creditor?: string;
    constructor(
        id: number,
        id_ips: string,
        id_creditor: string,
        programming: string,
        date_conciliation: string,
        modality_conciliation: string,
        balance_conciliation: string,
        explanation: string,
        refund: string,
        observations: string,
        is_active: string,
    ){
        this.id = id;
        this.id_ips = id_ips;
        this.id_creditor = id_creditor;
        this.programming = programming;
        this.date_conciliation = date_conciliation;
        this.modality_conciliation = modality_conciliation;
        this.balance_conciliation = balance_conciliation;
        this.explanation = explanation;
        this.refund = refund;
        this.observations = observations;
        this.is_active = is_active;
    }
  }
  
  export default Conciliation;
  